export class SearchError extends Error {
	name: string;
	statusCode: number;
	serverResult: ServerResult;

	constructor(serverResult: ServerResult) {
		super(serverResult.message);
		this.name = 'SearchError';
		this.statusCode = serverResult.status;
		this.serverResult = serverResult;
	}
}
